import FullScreenDialog from '../full-screen-dialog/FullScreenDialog';
import SettingsBar from '../settings-bar/SettingsBar';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import MobileGroupHierarchy from '../group-hierarchy/mobile/MobileGroupHierarchy';
import { INavigationItem } from '../../services/navigation-data-service/Models';
import WithIsLoadingHOC from "../../hocs/is-loading-hoc/IsLoadingHOC";

const MobileGroupHierarchyWithLoading = WithIsLoadingHOC(MobileGroupHierarchy);

export type MobileGroupPickerProps = {
    open: boolean;
    onClose: (item?: INavigationItem) => void,
    groupID?: number,
    hiddenGroups?: number[],
    rootID?: number
};

export default function MobileGroupPicker({
    //groupID,
    open, 
    onClose,
    rootID
    //hiddenGroups
}: MobileGroupPickerProps) {
    
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);    

    const onSelected = (item: INavigationItem): void => {

        if (onClose) {
            onClose(item);
        }
    };


    return (

        <FullScreenDialog open={open} onClose={() => onClose()}>

                <SettingsBar title={t('navigation.groups')} 
                            onClose={() => onClose()}
                            hideAction={true}
                             />                

                    <MobileGroupHierarchyWithLoading 
                        isLoading={loading}
                        onLoading={setLoading}                    
                        onSelected={onSelected} 
                        rootID={rootID}
                        />

        </FullScreenDialog>
    );
}
